import PanelInvitaJugar from './PanelInvitaJugar';
export default PanelInvitaJugar;
